import { alpha, styled } from '@mui/material'
import { FormAnswerStatus } from '@tabeeb/contracts/main-api/swagger-main-api'

import { Stack } from '@collaborate-health/uikit'

export const QuestionContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  borderColor: theme.palette.divider,
  borderWidth: 1,
  borderStyle: 'solid',
  overflow: 'hidden',
  scrollMarginTop: theme.spacing(1),
  scrollMarginBottom: theme.spacing(8),
}))

export const QuestionHeaderContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.palette.divider}`,
  height: 36,

  backgroundColor: theme.palette.background.default,

  [`&[data-answer-status="${FormAnswerStatus.Pending}"]`]: {
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
  },

  [`&[data-answer-status="${FormAnswerStatus.Pass}"],&[data-answer-status="${FormAnswerStatus.ApprovedByAI}"],&[data-answer-status="${FormAnswerStatus.ApprovedByReviewer}"]`]:
    {
      backgroundColor: alpha(theme.palette.success.main, 0.05),
    },

  [`&[data-answer-status="${FormAnswerStatus.Fail}"],&[data-answer-status="${FormAnswerStatus.RejectedByAI}"],&[data-answer-status="${FormAnswerStatus.RejectedByReviewer}"]`]:
    {
      backgroundColor: alpha(theme.palette.error.main, 0.05),
    },
}))

export const QuestionTitleContainer = styled('div')({
  flexGrow: 1,

  cursor: 'default',
  '&[data-clickable="true"]': {
    cursor: 'pointer',
  },
})

